import './App.css';
import { Store } from './screens/Store';

function App() {
  return (
    <div className="App">
      <Store />
    </div>
  );
}

export default App;
